import React from "react";

export default class DpcLinkUtili extends React.Component {
    render() {
        if (Array.isArray(this.props.linkUtili) && this.props.linkUtili.length > 0)
            return (
                <section className={`btn-block-uppercase-wrapper container ${this.props.classiAggiuntive ? ' '+this.props.classiAggiuntive : ' link-utili'}`}>
                    {this.props.titoloSezione && <h2>{this.props.titoloSezione}</h2>}
                    <div className={`px-custom`}>
                        <div className="row mb-3 btn-block-uppercase-wrapper">
                            {
                                this.props.linkUtili.map(row =>
                                    row &&
                                    <div className="col-md-3">
                                        <a href={row.slug} className={"btn btn-primary"} role="button" target={row.titleLinkEsterno ? '_blank':'_self'} rel="noopener noreferrer"
                                           title={row.titleLinkEsterno ? row.titleLinkEsterno : row.title}>
                                            {row.title}
                                        </a>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </section>
            );
        return ("");
    }
}
